import { render, staticRenderFns } from "./ImageCell.vue?vue&type=template&id=0c36e2e8&scoped=true&"
import script from "./ImageCell.vue?vue&type=script&lang=js&"
export * from "./ImageCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36e2e8",
  null
  
)

export default component.exports